"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QrCode = void 0;
var _presentationProductDetail = require("@ori/presentation-product-detail");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _contexts = require("../../contexts");
var _hooks = require("../../hooks");
var _useTranslations = require("../../hooks/useTranslations");
var _models = require("../../models");
var _utils = require("../../utils");
var _TextPositionCarousel = require("../TextPositionCarousel");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const QrCode = () => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    translations
  } = (0, _useTranslations.useTranslations)();
  const {
    imageRef,
    textPosition,
    setBackgroundColor,
    url
  } = (0, _contexts.useQrCodeDialog)();
  const {
    qrRef
  } = (0, _hooks.useQrCode)();
  const {
    shades,
    currentShade,
    currentColor
  } = (0, _hooks.useShades)();
  const size = (0, _utils.getQrSize)(url);
  const onShadeChange = (0, _react.useCallback)(shade => {
    setBackgroundColor(shade);
  }, [setBackgroundColor]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.QrRoot, {
      ref: imageRef,
      size: size,
      backgroundColor: currentColor?.backgroundColor,
      children: [textPosition !== _models.QRTextPosition.Blank ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.StyledTitle, {
        variant: "h4",
        textAlign: "center",
        textPosition: textPosition,
        children: translations.scanMe
      }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.QrCodeContainer, {
        ref: qrRef,
        "data-testid": getTestId(_constants.QR_CODE),
        size: size
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TextPositionCarousel.TextPositionCarousel, {}), currentShade ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.CarouselWrapper, {
      numberOfSlides: shades.length,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_presentationProductDetail.ShadesCarousel, {
        shouldReplaceUrl: false,
        shades: shades,
        currentShade: currentShade,
        setCurrentShadeProductCode: onShadeChange,
        navigation: {
          showArrows: false
        }
      })
    }) : null]
  });
};
exports.QrCode = QrCode;
